import PropTypes from 'prop-types';
import React from 'react';
import {
  BaseCard,
  BaseCardBody,
  BaseCardHeader,
  Button,
} from '@unite-us/ui';
import { epochToDate } from 'common/utils/utils';
import Address from 'common/display/Address';
import PhoneNumber from 'common/display/PhoneNumberDisplay';
import SimpleList from 'common/display/SimpleList';

const capitalizeWords = (str) => {
  if (!str) return '';
  return str.split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const ContactCard = ({
  id,
  contact,
  onSelectContact,
  indexNumber,
}) => (
  <li className="contact-card" role="article">
    <BaseCard>
      <BaseCardHeader
        title={(
          <b>
            {indexNumber !== undefined ?
        `${indexNumber + 1}: ${capitalizeWords(contact.full_name)}` :
        capitalizeWords(contact.full_name)}
          </b>
  )}
      />
      <BaseCardBody withPadding>
        <dl role="group" tabIndex="0" aria-label={`Date of Birth ${epochToDate(contact.date_of_birth)}`}>
          <dt aria-hidden="true">Date of Birth</dt>
          <dd aria-hidden="true">
            {epochToDate(contact.date_of_birth)}
          </dd>
        </dl>

        <dl role="group" tabIndex="0" aria-label="Phone information">
          <dt id={`${id}-phone-label`} role="term">Phone</dt>
          <dd id={`${id}-phone-value`} role="definition" aria-labelledby={`${id}-phone-label ${id}-phone-value`}>
            <SimpleList list={contact.phone_numbers} ListElement={PhoneNumber} />
          </dd>
        </dl>

        <dl role="group" tabIndex="0" aria-label="Address information">
          <dt id={`${id}-address-label`} role="term">Address</dt>
          <dd id={`${id}-address-value`} role="definition" aria-labelledby={`${id}-address-label ${id}-address-value`}>
            <SimpleList list={contact.addresses} ListElement={Address} shortDisplay />
          </dd>
        </dl>

        <Button
          id={`${id}-use-btn`}
          className="contact-card__confirmation"
          label="Use This Record"
          onClick={onSelectContact(contact)}
          primary
          ariaExpanded={null}
        />
      </BaseCardBody>
    </BaseCard>
  </li>
);

ContactCard.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.string,
    full_name: PropTypes.string,
    date_of_birth: PropTypes.number,
    phone_numbers: PropTypes.array,
    addresses: PropTypes.array,
  }).isRequired,
  id: PropTypes.string.isRequired,
  onSelectContact: PropTypes.func.isRequired,
  indexNumber: PropTypes.number,
};

export default ContactCard;
